import { AuthClient, decodeToken, removeKeyFromUrl } from '@skytech/auth'
import { getWhiteLabelBasedOnId } from '@skytech/utils'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

import authResources from '@/api/auth'
import { useAppContext } from '@/App.context'
import type { TokenData } from '@/types'
import getUserFromToken from '@/util/getUserFromToken'

const useLogIn = (config?: { isUrlCredentials?: boolean }) => {
  const navigate = useNavigate()
  const { setWhiteLabel } = useAppContext()

  const loginMutation = useMutation(
    (args: {
      phoneCountryId: number
      userName?: string
      password?: string
      accessCode?: string
      sessionId?: string
    }) => authResources.logIn(args),
    {
      onSuccess({ token }, variables) {
        AuthClient.setToken(token)

        const tokenData: TokenData = decodeToken(token)
        const user = getUserFromToken(tokenData)

        if (!user) return
        // Needs to be set manually as the hook has not been fired yet
        setWhiteLabel(getWhiteLabelBasedOnId(user.whiteLabelId))

        if (config?.isUrlCredentials) removeKeyFromUrl(navigate)
        if (variables.sessionId) {
          const url = new URL(window.location.href)
          url.searchParams.delete('sess-id')

          navigate(url.pathname + url.search)
        }
      },
      onError() {
        // We don't want to redirect from the login page when logging with credentials
        if (config?.isUrlCredentials) AuthClient.logOut({ isTriggeredProgrammatically: true })
      },
    }
  )

  return loginMutation
}

export default useLogIn
